const noAuthRequiredRoutes = [
  '#/guardian-permission',
  '#/terms-of-use',
  '#/privacy-policy',
  '#/audience-consent'
]

export const isAuthRequired = (pathName) => !noAuthRequiredRoutes.includes(pathName)
